import { PracticeBatterSessionReportChartConfigDto, PracticeBatterSessionSummaryChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo } from 'react';
import useReportStore from 'hooks/PracticeReport/Batter/reportStore';
import { PracticeBatterSessionSummaryChartColumn } from './PracticeBatterSessionSummaryChart';

const liveAtBatStats = [
  'walks',
  'strikeouts',
  'swingPercent',
  'contactPercent',
  'chasePercent',
] as PracticeBatterSessionSummaryChartColumn[];

const defaultDisabledVisibleStats = ['hitType', 'pitchType'];

const PracticeBatterSessionSummaryChartSidebar = (
  props: ChartConfigProps<PracticeBatterSessionSummaryChartConfigDto, PracticeBatterSessionReportChartConfigDto>
) => {
  const { chartConfig, setTempLayout, tempLayout } = props;
  const { t } = useTranslation();
  const { searchCriteria } = useReportStore();

  const disabledVisibleStats = useMemo(() => {
    return searchCriteria.sessionType?.id !== 'All' && searchCriteria.sessionType?.id !== 'LiveAB'
      ? [...defaultDisabledVisibleStats, ...liveAtBatStats]
      : [...defaultDisabledVisibleStats];
  }, [searchCriteria.sessionType]);

  useEffect(() => {
    let visibleStats = [...tempLayout.practiceBatterSessionSummaryChartConfig.visibleStats];

    if (searchCriteria.sessionType?.id !== 'All' && searchCriteria.sessionType?.id !== 'LiveAB') {
      liveAtBatStats.forEach((stat) => {
        const item = visibleStats.find((item) => item.key === stat);
        if (item) {
          item.checked = false;
        }
      });
    }

    setTempLayout({
      ...tempLayout,
      practiceBatterSessionSummaryChartConfig: {
        ...tempLayout.practiceBatterSessionSummaryChartConfig,
        visibleStats: visibleStats,
      },
    });
  }, [searchCriteria.sessionType]);

  return (
    <TableChartSidebar
      chartId='PracticeBatterSessionSummaryChart'
      configKey='practiceBatterSessionSummaryChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    >
      <GenericRadioConfig
        label={t('View data as:')}
        options={['HitType', 'PitchTypeOrGroup']}
        selected={chartConfig.grouping}
        setSelected={(selected) => {
          const updatedVisibleStats = tempLayout.practiceBatterSessionSummaryChartConfig.visibleStats.map((stat) => {
            if (stat.key === 'hitType') return { ...stat, checked: selected === 'HitType' };
            if (stat.key === 'pitchType') return { ...stat, checked: selected === 'PitchTypeOrGroup' };
            return stat;
          });

          setTempLayout({
            ...tempLayout,
            practiceBatterSessionSummaryChartConfig: {
              ...tempLayout.practiceBatterSessionSummaryChartConfig,
              grouping: selected,
              visibleStats: updatedVisibleStats,
            },
          });
        }}
        disabled={false}
      />
    </TableChartSidebar>
  );
};

export default PracticeBatterSessionSummaryChartSidebar;
